import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🧩 Stronger fix for ResizeObserver errors
const resizeObserverErr1 = "ResizeObserver loop completed with undelivered notifications.";
const resizeObserverErr2 = "ResizeObserver loop limit exceeded";

// Suppress browser errors
window.addEventListener("error", (e) => {
  if (e.message === resizeObserverErr1 || e.message === resizeObserverErr2) {
    e.stopImmediatePropagation();
  }
});

// Suppress console errors too
const origConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes(resizeObserverErr1) || args[0].includes(resizeObserverErr2))
  ) {
    return; // Ignore these ResizeObserver warnings
  }
  origConsoleError(...args); // Log everything else normally
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
